import { Button, Form } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { CallApi } from '../../../Components/common/CommonFunctions.js'; 

const GeneralSettings = () => {
  const isMounted = useRef(false);
  const storedData = JSON.parse(localStorage.getItem("Handler_stn")); 
  const station_id = storedData?.station_id;
  const org_station_id = storedData?.org_station_id;
  const [pgts, setPgts] = useState(storedData?.pgts || '');
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    if (isMounted.current) return;
    if (!storedData?.pgts) {
      loadStation();
    }
    isMounted.current = true;
  }, []);
  const loadStation = () => {
  CallApi({
    endPoint: 'organization-station/list',
    method: 'get',
    onSuccess: (res) => {
      const innerData = res?.data?.response_data;
      if (!innerData) return;
      const matchedStation = innerData.find(
        (item) => item.station_id === station_id
      );
      localStorage.setItem('Handler_stn', JSON.stringify(matchedStation));
      setPgts(matchedStation?.pgts || '');
    },
    onError: () => {
      toast.error("Failed to load station data");
    }
  });
};
  const handleInputChange = (e) => {
    setPgts(e.target.value);
  };
  const handleSavePgts = () => {
    if (!pgts.trim()) {
      toast.error('Please enter PGTS code.');
      return;
    }

    setIsSaving(true);

    CallApi({
      endPoint: "organization-station/add-edit",
      payload: { pgts, station_id, org_station_id,},
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res.data.response_msg);
          const updatedData = {...storedData, pgts};
          localStorage.setItem('Handler_stn', JSON.stringify(updatedData));
        } else {
          toast.error(res?.data?.response_msg || 'Failed to save PGTS code.');
        }
        setIsSaving(false);
      },
      onError: () => {
        toast.error('Something went wrong.');
        setIsSaving(false);
      }
    });
  };
  return (
    <div className='col-9 col-xxl-9 stting_right'>
      <div className='settingbg_right'>
        <div className='category_invoice_title'>
          <h4>General Settings</h4>
          <p>
            Set your notification preferences for when you are in or away from the dashboard.
          </p>
        </div>

        <div className='justify-content-start mb-3'>
          <div className='d-flex align-items-center mt-3'>
            <div className='me-3'>
              <h6>Add PGTS Code</h6>
            </div>
            <div style={{ width: '200px' }}>
              <Form.Control
                type="text"
                placeholder="Enter Pgts Code"
                value={pgts}
                onChange={handleInputChange}
              />
            </div>
            <Button
              variant="primary"
              onClick={handleSavePgts}
              disabled={isSaving}
              className="ms-2"
            >
              {isSaving ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;